export const PRECIO = '$19.990'
export const PRECIO_ANTERIOR = '$39.990'
export const MONEDA = 'ARS'

/* ---------------------------------------------------------------
 * IMÁGENES EDITABLES
 * Reemplazá cualquier URL de esta sección por tus imágenes reales.
 * Las medidas y el diseño se mantienen automáticamente.
 * ------------------------------------------------------------- */
export const IMAGENES = {
  portada:
    'https://cdn.magicpatterns.com/uploads/5mrmNgi3UZ1N4HEvNbxLz7/PORTADA_PUNTADAS_DE_PAPEL.png',
  videoPoster:
    'https://cdn.magicpatterns.com/patterns/generated-images/eb425bbd-6542-413a-9704-7cdf5dbc44aa.jpg',
  /* ▼ CARGAR VIDEO ▼
   * Pegá acá el enlace EMBED de tu video y aparecerá automáticamente en la
   * sección "Videos explicativos".
   *   YouTube  →  https://www.youtube.com/embed/CODIGO_DEL_VIDEO
   *   Vimeo    →  https://player.vimeo.com/video/CODIGO_DEL_VIDEO
   * Dejalo vacío ('') para seguir mostrando la portada con el botón de play.
   */
  videoEmbedUrl: '',
}

export type Plantilla = {
  id: string
  titulo: string
  categoria: string
  imagen: string
}

/* Carrusel 1 — PLANTILLAS (reemplazá `imagen` por tus plantillas reales) */
export const plantillas: Plantilla[] = [
  {
    id: 'p1',
    titulo: 'Ramo de flores',
    categoria: 'Floral',
    imagen:
      'https://cdn.magicpatterns.com/patterns/generated-images/a3bf4ea8-2f22-47a1-92d4-2fe46f572ad6.jpg',
  },
  {
    id: 'p2',
    titulo: 'Corazón de flores',
    categoria: 'Corazones',
    imagen:
      'https://cdn.magicpatterns.com/patterns/generated-images/21c7e02d-7143-4eda-9cf5-a2c1ac058371.jpg',
  },
  {
    id: 'p3',
    titulo: 'Ramas y hojas',
    categoria: 'Botánico',
    imagen:
      'https://cdn.magicpatterns.com/patterns/generated-images/154b3bda-6ddc-46cd-9cd2-adc8e9f20e55.jpg',
  },
  {
    id: 'p4',
    titulo: 'Frases bordadas',
    categoria: 'Letras',
    imagen:
      'https://cdn.magicpatterns.com/patterns/generated-images/fd68cbfb-921f-472b-9c22-eded5302d586.jpg',
  },
  {
    id: 'p5',
    titulo: 'Diseño minimalista',
    categoria: 'Minimal',
    imagen:
      'https://cdn.magicpatterns.com/patterns/generated-images/5c298da2-763b-4e0d-a83c-16b75175722f.jpg',
  },
  {
    id: 'p6',
    titulo: 'Tarjeta de cumpleaños',
    categoria: 'Ocasiones',
    imagen:
      'https://cdn.magicpatterns.com/patterns/generated-images/59222c4a-f815-48b5-a77b-771286fcc027.jpg',
  },
]

export type Proyecto = {
  id: string
  titulo: string
  etiqueta: string
  imagen: string
}

/* Carrusel 2 — PROYECTOS TERMINADOS (reemplazá `imagen` por tus fotos reales) */
export const proyectos: Proyecto[] = [
  {
    id: 'r1',
    titulo: 'Tarjeta con ramo bordado',
    etiqueta: 'Para regalar',
    imagen:
      'https://cdn.magicpatterns.com/patterns/generated-images/63f5cf7a-209f-46f6-902a-6cc7fde820a7.jpg',
  },
  {
    id: 'r2',
    titulo: 'Tarjeta de cumpleaños',
    etiqueta: 'Para sorprender',
    imagen:
      'https://cdn.magicpatterns.com/patterns/generated-images/59222c4a-f815-48b5-a77b-771286fcc027.jpg',
  },
  {
    id: 'r3',
    titulo: 'Lámina enmarcada',
    etiqueta: 'Para decorar',
    imagen:
      'https://cdn.magicpatterns.com/patterns/generated-images/119e5f85-f851-40fd-bf1f-5a231ad464f2.jpg',
  },
  {
    id: 'r4',
    titulo: 'Etiquetas y regalos',
    etiqueta: 'Para vender',
    imagen:
      'https://cdn.magicpatterns.com/patterns/generated-images/c8bfc136-6da7-40ba-8e33-fb8a810d9d2b.jpg',
  },
  {
    id: 'r5',
    titulo: 'Flores bordadas',
    etiqueta: 'Para disfrutar',
    imagen:
      'https://cdn.magicpatterns.com/patterns/generated-images/a3bf4ea8-2f22-47a1-92d4-2fe46f572ad6.jpg',
  },
  {
    id: 'r6',
    titulo: 'Diseños con frases',
    etiqueta: 'Para emocionar',
    imagen:
      'https://cdn.magicpatterns.com/patterns/generated-images/fd68cbfb-921f-472b-9c22-eded5302d586.jpg',
  },
]

export type Modulo = {
  etiqueta: string
  titulo: string
  descripcion: string
}

export const modulos: Modulo[] = [
  {
    etiqueta: 'Módulo 1',
    titulo: 'Tus Primeras Puntadas',
    descripcion:
      'Materiales, preparación del papel, perforaciones y tus primeras puntadas. Empezás desde cero y terminás tu primera pieza.',
  },
  {
    etiqueta: 'Módulo 2',
    titulo: 'Resultados Prolijos y Profesionales',
    descripcion:
      'Tensión del hilo, terminaciones limpias y combinaciones de color: los detalles que hacen que tus trabajos parezcan de tienda.',
  },
  {
    etiqueta: 'Módulo 3',
    titulo: 'De una Hoja a un Proyecto Completo',
    descripcion:
      'Convertí tus diseños en tarjetas, láminas y regalos terminados, listos para entregar, decorar o vender.',
  },
  {
    etiqueta: 'Biblioteca',
    titulo: '+100 Patrones para Imprimir',
    descripcion:
      'Más de 100 diseños listos para imprimir y bordar, sin tener que dibujar nada.',
  },
]

export type Bonus = {
  numero: string
  titulo: string
  descripcion: string
  imagen: string
}

export const bonos: Bonus[] = [
  {
    numero: 'Bonus 1',
    titulo: 'Abecedario Bordado Completo',
    descripcion:
      'Una colección de letras listas para utilizar en nombres, frases, iniciales, regalos y proyectos personalizados.',
    imagen:
      'https://cdn.magicpatterns.com/uploads/tCokLF52RLXN9WBFou3qTx/BONUS_1.png',
  },
  {
    numero: 'Bonus 2',
    titulo: '+200 Diseños de Inspiración',
    descripcion:
      'Una gran biblioteca visual para encontrar nuevas ideas, combinaciones y proyectos para crear.',
    imagen:
      'https://cdn.magicpatterns.com/uploads/whDVoxtGyLf3SRre6SNoya/BONUS_2.png',
  },
  {
    numero: 'Bonus 3',
    titulo: 'Tarjetas para Cada Ocasión',
    descripcion:
      'Diseños y propuestas para cumpleaños, agradecimientos, fechas especiales, regalos y celebraciones.',
    imagen:
      'https://cdn.magicpatterns.com/uploads/me56tfMdvAznixf1vhpN6f/BONUS_3.png',
  },
  {
    numero: 'Bonus 4',
    titulo: 'Bordá y Emprendé',
    descripcion:
      'Una guía pensada para quienes quieran transformar esta técnica en una pequeña fuente de ingresos.',
    imagen:
      'https://cdn.magicpatterns.com/uploads/3hGumdASB9wrFLvBCtdVS7/BONUS_4.png',
  },
]

export type Testimonio = {
  nombre: string
  lugar: string
  comentario: string
  /* Reemplazá por la captura real de WhatsApp / Instagram. Dejalo vacío para mostrar el placeholder. */
  imagen?: string
}

export const testimonios: Testimonio[] = [
  {
    nombre: 'Marta G.',
    lugar: 'Rosario',
    comentario:
      'Nunca había bordado en mi vida y en la primera tarde ya tenía mi primera tarjeta terminada. Me relaja muchísimo.',
    imagen: 'https://cdn.magicpatterns.com/uploads/xiXRUnzpxNLfFbaodxuyzr/image.png'
  },
  {
    nombre: 'Silvia R.',
    lugar: 'Córdoba',
    comentario:
      'Las explicaciones son clarísimas y los videos se ven perfecto desde el celular. Lo hago mientras tomo unos mates.',
    imagen: 'https://cdn.magicpatterns.com/uploads/wpLaof74yevDFintphE5t7/image.png'
  },
  {
    nombre: 'Alicia P.',
    lugar: 'Buenos Aires',
    comentario:
      'Le regalé a mi nieta una lámina bordada por mí y no lo podía creer. Ya me encargaron tres más.',
    imagen: 'https://cdn.magicpatterns.com/uploads/6cdW1fkR7kj2af5tHRtzgy/image.png'
  },
  {
    nombre: 'Norma D.',
    lugar: 'Mendoza',
    comentario:
      'Los patrones listos para imprimir me salvaron. No sé dibujar y aun así mis trabajos quedan preciosos.',
    imagen: 'https://cdn.magicpatterns.com/uploads/kKQifL9afiR4F1JBNCxwBL/image.png'
  },
  {
    nombre: 'Beatriz L.',
    lugar: 'La Plata',
    comentario:
      'Empecé como hobby y hoy vendo tarjetas personalizadas en mi barrio. La guía de emprender me ordenó mucho.',
    imagen: 'https://cdn.magicpatterns.com/uploads/927LrBKvsda5e4Uu2L851o/image.png'
  },
  {
    nombre: 'Cristina M.',
    lugar: 'Salta',
    comentario:
      'Me encanta que puedo ir a mi ritmo, repetir los videos y practicar cuando tengo un rato libre.',
    imagen: 'https://cdn.magicpatterns.com/uploads/aNo82Yc18z8SR38nHGBhju/image.png'
  },
  {
    nombre: 'Susana F.',
    lugar: 'Neuquén',
    comentario:
      'Con papel, hilo y una aguja armé los souvenirs del cumpleaños de mi hija. Quedaron hermosos.',
    imagen: 'https://cdn.magicpatterns.com/uploads/27GfSHCk2mANvQome4qxBR/image.png'
  },
  {
    nombre: 'Elena V.',
    lugar: 'Tucumán',
    comentario:
      'Buscaba algo para desconectarme del celular un rato y esto fue justo lo que necesitaba.',
    imagen: 'https://cdn.magicpatterns.com/uploads/oY5ckEjX46fMsbkFzTYPSx/image.png'
  },
  {
    nombre: 'Graciela A.',
    lugar: 'Mar del Plata',
    comentario:
      'El abecedario bordado es una maravilla. Hago iniciales personalizadas para regalar.',
    imagen: 'https://cdn.magicpatterns.com/uploads/6PD7qxQs87RVAN6cdyMHDp/image.png'
  },
]

export type Faq = {
  pregunta: string
  respuesta: string
}

export const faqs: Faq[] = [
  {
    pregunta: '¿Necesito saber bordar?',
    respuesta:
      'No. Puntadas de Papel está pensado para comenzar desde cero. Empezamos por las puntadas más simples y avanzamos paso a paso, a tu ritmo.',
  },
  {
    pregunta: '¿Qué materiales necesito?',
    respuesta:
      'Materiales muy accesibles: papel o cartulina, hilo de bordar, una aguja, tijera y algo para perforar (un alfiler o punzón). Dentro del curso te contamos exactamente qué comprar y dónde conseguirlo.',
  },
  {
    pregunta: '¿Las plantillas se pueden imprimir?',
    respuesta:
      'Sí. Todas las plantillas están listas para imprimir desde tu casa o en cualquier imprenta, en hoja A4, y podés reutilizarlas todas las veces que quieras.',
  },
  {
    pregunta: '¿Cómo recibo el contenido?',
    respuesta:
      'Es 100% digital. Después de la compra recibís automáticamente el acceso online, desde cualquier país y desde el celular, la tablet o la computadora.',
  },
  {
    pregunta: '¿Puedo vender las cosas que hago?',
    respuesta:
      'Sí. Podés usar lo aprendido para crear tus propios productos artesanales, como tarjetas, láminas o regalos personalizados.',
  },
]

export const checklistOferta: string[] = [
  'Módulo 1 — Tus Primeras Puntadas',
  'Módulo 2 — Resultados Prolijos y Profesionales',
  'Módulo 3 — De una Hoja a un Proyecto Completo',
  'Biblioteca con +100 patrones imprimibles',
  'Videos explicativos paso a paso',
  'BONUS 1 — Abecedario Bordado Completo',
  'BONUS 2 — +200 Diseños de Inspiración',
  'BONUS 3 — Tarjetas para Cada Ocasión',
  'BONUS 4 — Bordá y Emprendé',
]
